/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import appConfig from 'scripts/app-config';
import template from './course-statistics-head.stache';
import _ from 'lodash';
import can from 'can';

function getActiveFilter(isSummary, roundLength) {
    if (isSummary) return 'summary';
    if (roundLength) return 'round-1';

    return 'all-rounds';
}

Component.extend({
    tag: 'course-statistics-head',
    template,
    viewModel: {
        define: {
            filters: {
                get() {
                    let filters = [];
                    const isSummary =
                        this.summary && this.summary.rounds.length;
                    const roundsLength =
                        this.roundsInfo && this.roundsInfo.rounds.length;
                    const isAllRounds = _.has(this.roundsInfo, 'allRounds');

                    if (isSummary) {
                        filters.push({
                            title: 'Summary by round',
                            value: 'summary',
                        });
                    }

                    if (roundsLength) {
                        this.roundsInfo.rounds.forEach((round, index) => {
                            filters.push({
                                title: 'Round ' + (index + 1),
                                value: 'round-' + (index + 1),
                            });
                        });
                    }

                    if (isAllRounds) {
                        filters.push({
                            title: 'All rounds',
                            value: 'all-rounds',
                        });
                    }

                    filters.push({
                        title: 'Missed fairway penalty',
                        value: 'missed-fairway',
                    });

                    this.attr(
                        'activeFilter',
                        getActiveFilter(isSummary, roundsLength),
                    );

                    return filters;
                },
            },
        },
        onTabChange(event) {
            can.route.attr({ round: event.payload.value });
        },
    },
    events: {
        inserted() {
            can.route.bind('change', (ev, attr, how, newVal, oldVal) => {
                if (attr == 'round') {
                    this.viewModel.attr('activeFilter', newVal);
                }
            });

            can.route.ready();

            if (!can.route.attr('round')) {
                can.route.attr({ round: this.viewModel.attr('activeFilter') });
            } else {
                this.viewModel.attr('activeFilter', can.route.attr('round'));
            }
        },
    },
});
